export var ErrorCode;
(function (ErrorCode) {
    ErrorCode["ERR_NOT_FOUND"] = "ERR_NOT_FOUND";
    ErrorCode["ERR_BAD_REQUEST"] = "ERR_BAD_REQUEST";
    ErrorCode["ERR_UNAUTHORIZED"] = "ERR_UNAUTHORIZED";
    ErrorCode["ERR_FORBIDDEN"] = "ERR_FORBIDDEN";
    ErrorCode["ERR_INTERNAL_SERVER_ERROR"] = "ERR_INTERNAL_SERVER_ERROR";
    ErrorCode["ERR_VALIDATION"] = "ERR_VALIDATION";
    ErrorCode["ERR_ALREADY_EXISTS"] = "ERR_ALREADY_EXISTS";
    ErrorCode["AUTHZ_DENIED"] = "authz_denied";
    ErrorCode["ERR_IAM_SELF_ACCESS_CHANGE"] = "ERR_IAM_SELF_ACCESS_CHANGE";
    ErrorCode["ERR_IAM_LAST_ADMIN"] = "ERR_IAM_LAST_ADMIN";
    ErrorCode["ERR_IAM_GRANT_EXCEEDS_OWN_ACCESS"] = "ERR_IAM_GRANT_EXCEEDS_OWN_ACCESS";
    ErrorCode["ERR_IAM_DUPLICATE_ROLE"] = "ERR_IAM_DUPLICATE_ROLE";
    ErrorCode["ERR_IAM_VERSION_CONFLICT"] = "ERR_IAM_VERSION_CONFLICT";
    ErrorCode["ERR_IAM_ROLE_IN_USE"] = "ERR_IAM_ROLE_IN_USE";
    ErrorCode["ERR_IAM_PLATFORM_ROLE_READ_ONLY"] = "ERR_IAM_PLATFORM_ROLE_READ_ONLY";
    ErrorCode["ERR_IAM_UNAVAILABLE"] = "ERR_IAM_UNAVAILABLE";
})(ErrorCode || (ErrorCode = {}));
const defaultErrorCode = ErrorCode.ERR_INTERNAL_SERVER_ERROR;
export var DefaultErrorMessage;
(function (DefaultErrorMessage) {
    DefaultErrorMessage["ERR_NOT_FOUND"] = "Not found";
    DefaultErrorMessage["ERR_BAD_REQUEST"] = "Bad request";
    DefaultErrorMessage["ERR_UNAUTHORIZED"] = "Unauthorized";
    DefaultErrorMessage["ERR_FORBIDDEN"] = "Forbidden";
    DefaultErrorMessage["ERR_INTERNAL_SERVER_ERROR"] = "Internal server error";
    DefaultErrorMessage["ERR_VALIDATION"] = "Validation error";
    DefaultErrorMessage["ERR_ALREADY_EXISTS"] = "Resource already exists";
    DefaultErrorMessage["authz_denied"] = "You don't have permission to do this.";
    DefaultErrorMessage["ERR_IAM_SELF_ACCESS_CHANGE"] = "You can't change your own access. Ask another admin.";
    DefaultErrorMessage["ERR_IAM_LAST_ADMIN"] = "The account needs at least one admin. Make someone else an admin first.";
    DefaultErrorMessage["ERR_IAM_GRANT_EXCEEDS_OWN_ACCESS"] = "You can only give access you have yourself.";
    DefaultErrorMessage["ERR_IAM_DUPLICATE_ROLE"] = "A role with the same permissions already exists.";
    DefaultErrorMessage["ERR_IAM_VERSION_CONFLICT"] = "This was changed in the meantime. Reload it and try again.";
    DefaultErrorMessage["ERR_IAM_ROLE_IN_USE"] = "Someone holds this role. Give them another role before deleting it.";
    DefaultErrorMessage["ERR_IAM_PLATFORM_ROLE_READ_ONLY"] = "PlanIT Geo roles can't be changed. Duplicate the role instead.";
    DefaultErrorMessage["ERR_IAM_UNAVAILABLE"] = "Access can't be checked right now. Try again shortly.";
})(DefaultErrorMessage || (DefaultErrorMessage = {}));
export class ApplicationError extends Error {
    constructor(options = {}) {
        let { code, messageExternal, messageInternal } = options;
        code = code || defaultErrorCode;
        messageExternal = messageExternal || DefaultErrorMessage[code] || '';
        messageInternal = messageInternal || messageExternal || '';
        super(messageInternal);
        this.options = options;
        this.messageExternal = messageExternal;
        this.code = code;
    }
}
//# sourceMappingURL=application-error.js.map